<template>
	<div id="box">
		<div id="c_wrap">
			<div class="download_header">
				<img class="download_header_img" src="../assets/img/download/DGgonggao.png" />
			</div>
			<!--体开始-->
			
			<div class="download_main">
			<div class="down_navigation1" style="color: #BDBDBD;">
				<a><router-link to="/"style="text-decoration: none;color: #BDBDBD;">首页</router-link></a> > <a style="text-decoration: none;color: #076bf2;" href="#">公告中心</a>
			</div>
				<div class="download_main_in">
					<div class="notice_list" v-for="item in noticeList">
						<div class="download_main_menu">
								<router-link :to="{path:'/noticePage', query:{uuid:item.contentcode}}" size="1">{{item.title}}</router-link>
						</div>
							<span class="download_main_size">{{item.time}}</span>
						<!--<hr class="download_main_blank" />-->
					</div>
					
					<div class="download_main_page">
					</div>
					<div class="download_main_page1">
						<div class="download_main_page3">
							<span style="cursor: pointer;" class="annou" @click="prePage"> </span><a style="size: a3;">{{page}}/{{countPage}}</a> <span style="cursor: pointer;" class="annou1" @click="nextPage"> </span>
						</div>
						<div class="download_main_page2">
							<input style="text-align: center;" class="page2-ipt" v-model="jumpPage"/>
						</div>
						<div class="download_main_page2">
							<span style="cursor: pointer;color: white;" class="page2-btn" @click="jump">跳转</span>
						</div>
					</div>
				</div>
			</div>
		</div>
			<!--体结束-->
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				noticeList:'',		//公告列表数据
				page:'1',			//当前页码
				countPage:'',		//总页码
				jumpPage:'',		//跳转的页码
			}
		},
		mounted(){
			this.queryData();
		},
		methods:{
			//上一页
			prePage(){
				if(this.page >1){
					this.page--;
					this.queryData();
				}
				
				
			},
			//下一页
			nextPage(){
				if(this.page < this.countPage){
					this.page++;
					this.queryData();
				}
				
				
			},
			
			//跳转
			jump(){
				if(this.jumpPage < '1' || this.jumpPage > this.countPage){
					
					this.jumpPage = this.page;
				}else{
					if(typeof(this.jumpPage)==='number'){
						this.page = this.jumpPage;
					this.queryData();
					}
				}
			},
			
			queryData(){
				let _this=this;
				//获取数据
				this.$http.get(
					_this.apiUrl+'index.php? m=Api&c=content&a=notice_list',
					{
						params: {  
							"page":this.page
						}  
					}
					).then(response => {
						//进行数据验证
						if(response.body.status != 1){
							
							//显示错误页面
//							alert('请求错误');
							return;
						}
						
						if(typeof response.body.data == "undefined" || response.body.data == null || response.body.data == ""){
							
							//显示空数据页面
//							alert('没有数据');
							this.$message({
								message: '暂无数据',
								type: 'warning',
								customClass: 'message-warning',
							});
							return;
						}
						
						this.noticeList = response.body.data.noticeList;
						this.countPage = response.body.data.countPage;
	
				}, response => {
//					console.log("error");
				});
			}
		}
	}
</script>

<style>
	#c_wrap{
		box-sizing: border-box;
		width: 100%;
	}
	#box{
		min-height: 100%;
		width: 100%;
		/*padding-top: 70px;*/
		box-sizing: border-box;
		background: #f3f3f3;
	}
	.down_navigation1{
		height: 40px;
		width: 1200px;
		line-height: 40px;
		text-align: left;
		margin: 0 auto;
		margin-top: 10px;
		background-color: #F3F3F3;
	}
	.download_header {
		width: 100%;
	}
	.notice_list{
		overflow: hidden;
		margin: 0 auto;
		width: 1140px;
		border-bottom: 1px solid #DCDCDC;
	}
	/*.notice_list:nth-child(10n+10){
		border: 0;
	}*/
	.notice_list:nth-last-child(10n-7){
		border: 0;
	}
	.download_header_img {
		height: 100%;
		width: 100%;
		float: left;
	}
	.download_main {
		width: 100%;
		height: 100%;
		float: left;
		background-color: #F3F3F3;
	}
	.download_main_in {
		width: 1200px;
		margin: 0 auto;
		background-color: #F3F3F3;
		border: 2px #DCDCDC solid;
	}
	
	.download_main_menu {
		line-height: 50px;
		width: 85%;
		height: 50px;
		float: left;
		text-align: left;
	}
	.download_main_menu a{
		color: #222222;
		text-decoration: none;
	}
	
	.download_main_blank {
		border-top: 1px solid #DCDCDC;
		margin: 0px 20px 0px 20px;
	}
	
	.download_main_size {
		color: #999;
		font-family: '微软雅黑';
		display: inline-block;
		height: 50px;
		line-height: 50px;
		float: right;
	}
	.download_main_size a{
		text-decoration: none;
		color:#000;
	}
	
	.download_main_page {
		width: 70%;
		height: 60px;
		float: left;
	}
	
	.download_main_page1 {
		width: 30%;
		height: 60px;
		float: left;
	}
	
	.download_main_page2 {
		width: 30%;
		height: 40px;
		float: left;
		margin-left: 5px;
		margin-top: 20px;
	}
	.download_main_page3 {
		width: 30%;
		height: 40px;
		line-height: 40px;
		float: left;
		margin-left: 5px;
		margin-top: 20px;
	}
	.page2-btn {
		display: inline-block;
		width: 80px;
		height:36px;
		line-height: 36px;
		border-radius: 5px;
		background-color: #076bf2;
	}
	
	.page2-ipt {
		width: 80px;
		height: 36px;
		line-height: 36px;
		border-radius: 5px;
	}
	.annou{
		margin-top: 5px;
		float: left;
		/*background: url(../assets/images/pageleft.png) no-repeat center;*/
		width: 28px;
		height: 28px;
		display: block;
		/*border-radius: 5px;*/
		background-color: #E6E6E6;
		outline: none;
	}
	.annou1{
		margin-top: 5px;
		float: right;
		display: block;
		/*background: url(../assets/images/pageright.png) no-repeat center;*/
		width: 28px;
		height: 28px;
		/*border-radius: 5px;*/
		background-color: #E6E6E6;
		outline: none;
	}
	
</style>


// WEBPACK FOOTER //
// src/views/announcementPage.vue